import styled from 'styled-components';
import { CredusButton, CredusText } from 'ui';
import { NoDataIcon } from '../../../../assets/images/svgs';

interface OnboardCandidatesProps {
  setShowImportCandidate: React.Dispatch<React.SetStateAction<boolean>>;
}

const OnboardCandidates = ({
  setShowImportCandidate,
}: OnboardCandidatesProps) => {
  const handleClick = () => {
    setShowImportCandidate(true);
  };
  return (
    <Container>
      <CredusButton size="medium" onClick={handleClick}>
        Onboard Candidates
      </CredusButton>
      <Div>
        <NoDataIcon />
        <CredusText size="lg" weight="regular">
          No available candidates
        </CredusText>
      </Div>
    </Container>
  );
};

export default OnboardCandidates;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7rem;
`;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;
